// DS6.10 for gallections
import React from 'react';
import { useTranslation } from 'react-i18next';
import ImageIcon from '@wix/da-ds/pkg/Icons/24x24/Image';
import DeviantsIcon from '@wix/da-ds/pkg/Icons/24x24/AllDeviants';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import s from './FolderStats.scss';
const FolderStats = ({ folder, showCountsWithoutCaptions, withSubscribersCount = true })=>{
    var _folder_premiumFolderData;
    const { t } = useTranslation();
    var _folder_totalItemCount, _ref;
    const folderSize = (_ref = (_folder_totalItemCount = folder.totalItemCount) !== null && _folder_totalItemCount !== void 0 ? _folder_totalItemCount : folder.size) !== null && _ref !== void 0 ? _ref : 0;
    var _folder_premiumFolderData_numSubscribers;
    const subscribersCount = (_folder_premiumFolderData_numSubscribers = (_folder_premiumFolderData = folder.premiumFolderData) === null || _folder_premiumFolderData === void 0 ? void 0 : _folder_premiumFolderData.numSubscribers) !== null && _folder_premiumFolderData_numSubscribers !== void 0 ? _folder_premiumFolderData_numSubscribers : 0;
    return /*#__PURE__*/ React.createElement("div", {
        className: s['root']
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['stat']
    }, /*#__PURE__*/ React.createElement(ImageIcon, {
        size: IconSize.SMALLER,
        disableDefaultColors: true
    }), /*#__PURE__*/ React.createElement("span", {
        className: s['label']
    }, showCountsWithoutCaptions ? folderSize : t('folderCard.stats.artworks', {
        count: folderSize
    }))), withSubscribersCount && !!subscribersCount && /*#__PURE__*/ React.createElement("div", {
        className: s['stat']
    }, /*#__PURE__*/ React.createElement(DeviantsIcon, {
        size: IconSize.SMALLER,
        disableDefaultColors: true
    }), /*#__PURE__*/ React.createElement("span", {
        className: s['label']
    }, showCountsWithoutCaptions ? subscribersCount : t('folderCard.stats.subscribers', {
        count: subscribersCount
    }))));
};
FolderStats.displayName = 'FolderStats';
export default FolderStats;

//# sourceMappingURL=FolderStats.js.map